export default "__VITE_ASSET__97kkOjO4__"